const THRESHOLD = 0.5;
const CURRENT_CLASS = "is-current";

for (const carousel of document.querySelectorAll(".carousel")) {
  const viewport = carousel.querySelector(".carousel__slides");
  if (viewport == null) throw new Error("Carousel with no viewport");

  const slides: NodeListOf<HTMLElement> =
    viewport.querySelectorAll(".carousel__slide");
  const pips: NodeListOf<HTMLElement> = carousel.querySelectorAll(
    ".carousel__nav button"
  );
  if (slides.length !== pips.length)
    throw new Error("Slides length is not the same as pips length");

  // Handle clicks on pips
  for (const [index, pip] of pips.entries()) {
    pip.addEventListener("click", () => {
      viewport.scrollTo({
        left: slides[index].offsetLeft,
        behavior: "smooth",
      });
    });
  }

  // Keep track of which slide is current
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const index = [...slides].findIndex((slide) => slide === entry.target);
        if (index === -1) continue;
        const pip = pips[index];
        pip.classList.toggle(
          CURRENT_CLASS,
          entry.intersectionRatio >= THRESHOLD
        );
      }
    },
    {
      root: viewport,
      threshold: THRESHOLD,
    }
  );
  for (const slide of slides) {
    observer.observe(slide);
  }

  // Scroll current slide into view on resize
  window.addEventListener("resize", () => {
    const index = [...pips].findIndex((pip) =>
      pip.classList.contains(CURRENT_CLASS)
    );
    const slide = slides[Math.max(0, index)];
    viewport.scrollTo({
      left: slide.offsetLeft,
      behavior: "auto",
    });
  });
}
